import api from 'services/api/microfwk';

export const logOut = params => api.get('/services/user/logout', { params });